import React, {useCallback, useState} from 'react';

import styles from './LanguagesSelect.module.css';
import { useTranslation } from 'react-i18next';
import { dispatch } from 'store';
import {setCurrentCountry, setCurrentLanguage} from 'modules/app/actions';
import { useSelector } from 'react-redux';
import { RootState } from 'types';
import {CountriesListProps} from "../../../modules/user/types";
import Select from 'react-select';
import {history} from 'services/history';
import {setCurrency, updateUserInfo} from "../../../modules/user/actions";
import { getStripePrices, setBillingType, setRegisterData } from 'modules/auth/actions';
import { useQuery } from 'utils';

interface LanguageProps {
  value: string;
  label: string;
  shortName: string;
  lang: string;
  icon: string;
  curr_code: string;
}

export const LanguagesSelect = () => {
  const { i18n } = useTranslation();
  const plan = useQuery().get('plan') || '';
  const [isPlan, setPlan] = useState((plan && `&plan=${plan}`));  
  
  const { currentLanguage, currentCountry } = useSelector((state: RootState) => state.app);
  const { countriesList, userInfo } = useSelector((state: RootState) => state.user);
  const { token } = useSelector((state: RootState) => state.auth);
  const countryCodesList = useCallback(() => {
    if(countriesList && countriesList.length) {
      const  arr = [...countriesList];
      const newArr = arr.sort(function(a, b) {
        const nameA = a.id;
        const nameB = b.id;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return newArr.map((i: CountriesListProps) => {
        return {
          value: i.id,
          label: i.name,
          shortName: i.short_name,
          icon: i.icon,
          lang: i.language_code,
          curr_code: i.curr_code
        }
      })
    }
    return []
  }, [countriesList]);  

  const SingleValue = (props: any) => {
    const {getValue} = props;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <div style={{width: 20, height: 20}}><img style={{width: '100%', height: '100%', objectFit: 'contain'}} src={getValue()[0].icon} /></div>
        <div style={{ marginLeft: 5 }}>{getValue()[0].label}</div>
      </div>
    );
  };

  const getOptionsValue = (props: LanguageProps) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={props.icon} style={{width: 20, height: 20, objectFit: 'contain'}}/>
        {/*{e.icon}*/}
        <span style={{ marginLeft: 5 }}>{props.label}</span>
      </div>
    )
  };

  const handleChange = (code: LanguageProps) => {
    const name = 'country';
    const value = code.label;
    dispatch(setCurrency(code.curr_code));
    dispatch(getStripePrices.request());
    dispatch(setCurrentLanguage(code.value));
    dispatch(setCurrentCountry(code.shortName));
    dispatch(setRegisterData(name, value));
    dispatch(setBillingType('Monthly'));
    token && dispatch(updateUserInfo.request());
    localStorage.setItem('lng', code.lang);
    localStorage.setItem('country', code.shortName);
    i18n.changeLanguage(code.lang);
    
    const params = () => {
      switch (code.shortName) {
        case 'UK' : {
          return isPlan || (plan && `&plan=${plan}`) || '';
          break;
        }
        case 'NL': {
          return isPlan || (plan && `&plan=${plan}`) || '';
          break;
        }
        case "DE" : {
          return isPlan || (plan && `&plan=${plan}`) || '';
          break;``
        }
        case "EU" : {
          return isPlan || (plan && `&plan=${plan}`) || '';
          break;``
        }
        default:
          // setPlan(isPlan || (plan && `&plan=${plan}`) || '');
          return isPlan || (plan && `&plan=${plan}`) || '';;
          break;
      }
    }
    
    history.push(`?location=${code.shortName}${params()}`);
  }

  return (
    <div style={{width: 280}}>
      <Select
        value={countryCodesList().find(i => {
          return (userInfo && userInfo.country && userInfo.country.length && 
            userInfo.country[0].short_name === i.shortName) ||
          (+i.value === +currentLanguage) ||
            (i.shortName.toLowerCase() === currentCountry.toLowerCase())
        })}
        className={styles.main}
        onChange={handleChange}
        components={{ SingleValue }}
        getOptionLabel={(e: any) => getOptionsValue(e)}
        options={countryCodesList()}
      />
      </div>
  );
};